import { combineReducers } from 'redux';
import { userIdActionReducer, loggedInUserActionReducer } from "../common/users/actionsReducers";
import { playersActionReducer } from "../common/players/actionsReducers";
import { ageGroupActionReducer } from "../common/ageGroupActionsReducers";
import { errorsReducer } from "../common/errorActionsReducers";
import { leagueMatchAdminActionReducer } from "../pages/DBF/Admin/Holdkamp/actionsReducers";
const userIdReducer = userIdActionReducer.buildReducer();
const userLoggedInReducer = loggedInUserActionReducer.buildReducer();
const rootReducer = (history) => combineReducers({
    leagueTeams: leagueMatchAdminActionReducer.buildReducer(),
    users: combineReducers({ usersById: userIdReducer, loggedInUser: userLoggedInReducer }),
    players: playersActionReducer.buildReducer(),
    ageGroups: ageGroupActionReducer.buildReducer(),
    errors: errorsReducer
});
export default rootReducer;
